﻿//==========================================================================================================
// Copyright (C) Nore Technology AB. All Rights Reserved.
//==========================================================================================================

//-------------------------------------------------------------------------------------
// Imports
//-------------------------------------------------------------------------------------

import { JssClass, applyThemeStyles } from "~base/Styling";
import { createUseStyles } from "react-jss";
import { ConsilioBaseTheme } from "~base/Styling/ConsilioTheme";

//-------------------------------------------------------------------------------------
// Styling
//-------------------------------------------------------------------------------------

export interface LoginPageClasses {
    splashButton: string;
    loginButton: string;
    loginTypeSeparator: string;
}

export interface LoginPageStyles {
    splashButton?: JssClass;
    loginButton?: JssClass;
    loginTypeSeparator: string;
}

export const useStyles = (customStyles: LoginPageStyles): LoginPageClasses =>
    createUseStyles((theme: ConsilioBaseTheme) => ({
        splashButton: applyThemeStyles(
            theme.components.pages.shared.splashPage.splashScreen,
            applyThemeStyles(customStyles?.splashButton, {})
        ),
        loginButton: applyThemeStyles(customStyles?.loginButton, {}),
        loginTypeSeparator: {
            width: "100%",
            marginTop: "10px",
            marginBottom: "10px",
        },
    }))();
